<div class="row">
    <div class="col-md-12">
        <form [formGroup]="form">
            <div class="editor" style="border: solid 1px #d6d3d3; border-radius:5px; margin:5px;">

                <ngx-editor (click)="showEmojis=false" formControlName="content" [editor]="editor" [ngModel]="html"
                    [disabled]="false" [placeholder]="'Escriba su mensaje'">
                </ngx-editor>
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [customMenuRef]="customMenu"> </ngx-editor-menu>
            </div>
            <div class="col-md-12">
                <label class="small mb-1" for="whatsapp">Whatsapp</label>
                <div class="input-group flex-nowrap">
                    <select class="form-select" formControlName="code">
                        <option value="{{item.code}}" *ngFor="let item of codephones">+{{item.code}} {{item.tag}}
                        </option>
                    </select>
                    <span class="input-group-text" id="addon-wrapping"><i class="fa-brands fa-whatsapp"></i></span>
                    <input type="phone" formControlName="phone" class="form-control w-70" placeholder="Whatsapp">
                </div>
            </div>
            <a class="btn btn-success" *ngIf="form.get('content').value" target="_blank" [href]="textToWsp()">Envio
                Whatsapp Web</a>
        </form>
    </div>


</div>

<!-- Create template reference -->
<ng-template #customMenu>
    <app-ngx-editor-emoji />
</ng-template>